<template>
  <main style="opacity: 0;">
    <div class="block">
      <Counter
        number="01"
        data-anim="fade"
        data-view="false"
      />
      <a
        :href="links.about"
        data-nav="about"
        :aria-label="structure[0].title"
        @click.prevent="$goTo(links.about, 'parent-child');"
      >
        <Title
          size="big"
          :text="structure[0].title"
          data-anim="title"
          data-view="false"
        />
      </a>
      <a
        :href="links.about"
        :aria-label="structure[0].title"
        @click.prevent="$goTo(links.about, 'parent-child');"
      >
        <Paragraph
          size="big"
          :text="structure[0].text"
          data-anim="text"
          data-view="false"
        />
      </a>
    </div>
    <div class="block">
      <Counter
        number="02"
        data-anim="fade"
        data-view="false"
      />
      <a
        :href="links.investimenti"
        data-nav="investimenti"
        :aria-label="structure[1].title"
        @click.prevent="$goTo(links.investimenti, 'parent-child');"
      >
        <Title
          size="big"
          :text="structure[1].title"
          data-anim="title"
          data-view="false"
        />
      </a>
      <a
        :href="links.investimenti"
        :aria-label="structure[1].title"
        @click.prevent="$goTo(links.investimenti, 'parent-child');"
      >
        <Paragraph
          size="big"
          :text="structure[1].text"
          data-anim="text"
          data-view="false"
        />
      </a>
    </div>
    <div class="block">
      <Counter
        number="03"
        data-anim="fade"
        data-view="false"
      />
      <a
        :href="links.team"
        :aria-label="structure[2].title"
        @click.prevent="$goTo(links.team, 'parent-child');"
      >
        <Title
          size="big"
          :text="structure[2].title"
          data-anim="title"
          data-view="false"
        />
      </a>
      <a
        :href="links.team"
        :aria-label="structure[2].title"
        @click.prevent="$goTo(links.team, 'parent-child');"
      >
      <Paragraph
        size="big"
        :text="structure[2].text"
        data-anim="text"
        data-view="false"
      />
      </a>
    </div>
  </main>
</template>

<script>
import Counter from '@/components/text/Counter.vue';
import Title from '@/components/text/Title.vue';
import Paragraph from '@/components/text/Paragraph.vue';

export default {
  name: 'Index',

  components: {
    Counter,
    Title,
    Paragraph,
  },

  computed: {
    structure() {
      const data = this.$store.state.firebase;
      const { lang } = this.$store.state;
      const structure = data.home.structure[lang];
      const s = [];
      Object.keys(structure).forEach((key) => {
        s.push(structure[key].data);
      });
      return s;
    },
    links() {
      const data = this.$store.state.firebase;
      const s = {};
      const { lang } = this.$store.state;
      const pathLang = this.$store.state.lang === 'it' ? 'path' : 'pathEn';

      Object.keys(data).forEach((key) => {
        if (key !== 'home') {
          const link = `/${lang}${data[key][pathLang]}`;
          s[key] = link;
        }
      });

      return s;
    },
  },
};
</script>

<style lang="scss" scoped>
.block {
  & + .block {
    margin-top: rem(80px);
  }
}
</style>
